import { useEffect, useState } from 'react';
import { useSignatures } from 'hooks/useSignaturesQuery';
import type { SectionsSignaturesType, SignatureBox } from 'services/entities/SignatureTypes';

export type SetSignedSignatureInSectionType = (signedSignature: SignatureBox, sectionId: string) => void;

export const usePreviewSignatures = ({ contentId }: { contentId: string }) => {
  const [sectionsSignatures, setSectionsSignatures] = useState<SectionsSignaturesType>({});

  const { data } = useSignatures({ contentId });

  const setSignedSignatureInSection: SetSignedSignatureInSectionType = (signedSignature, sectionId) => {
    setSectionsSignatures((prevSectionSignatures) => {
      return {
        ...prevSectionSignatures,
        [sectionId]: [
          ...prevSectionSignatures[sectionId].map((signature) => {
            return signature.signatureBoxId === signedSignature.signatureBoxId ? signedSignature : signature;
          }),
        ],
      };
    });
  };

  useEffect(() => {
    if (!data) return;

    setSectionsSignatures(data);
  }, [data]);

  return { sectionsSignatures, setSignedSignatureInSection };
};
